import * as React from "react";

const EmptySelectOption: React.VFC = () => <option value="" selected={true} hidden={true}></option>;

export default EmptySelectOption;
